<template>
    <base-success title="Great! Your camp is added"
                  add-label="Add another camp"
                  view-label="View your camps"
                  :view-route="Routes.CAMP_PAGE"
                  :callback="createNewCamp">
    </base-success>
</template>

<script>
    import { mapActions } from 'vuex';
    import * as Routes from '@/router/routes';

    export default {
        name: 'Success',
        components: {
            BaseSuccess: () => import('@/components/main/pages/base/BaseSuccess')
        },
        data() {
            return {
                Routes
            }
        },
        methods: {
            ...mapActions({
                createNewCamp: 'goToCampCreationStart'
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/Success.vue